import React from "react";
import { getLockscreenTheme } from "../utils/lockscreen-utils";
import AsyncImage from "./Generic/AsyncImage";
import MedFlytDecorativeLogo from "./MedFlytDecorativeLogo";
import PinInput from "./PinInput";

interface Props {
  pinValue: string;
  headline: string;
  footer?: React.ReactNode;
  onChangePin: (pin: string) => void;
}

const PinCodeScreen = (props: Props) => {
  const theme = getLockscreenTheme();

  return (
    <div className="PinCodeScreen">
      <div className="container">
        <h3>{props.headline}</h3>

        <PinInput value={props.pinValue} onChange={props.onChangePin} />

        {props.footer}
      </div>
      <div className="background">
        {theme.hideLogo ?? false ? null : <MedFlytDecorativeLogo color={theme.foreground} />}
        <AsyncImage
          src={theme.wallpaper}
          className="img"
          style={{
            backgroundPosition: theme.position,
            backgroundSize: theme.size,
          }}
        />
      </div>
    </div>
  );
};

export default React.memo(PinCodeScreen);
